<svelte:options

  customElement = {{
    shadow: "none",
    tag: "ofc-sponsored-tag-v1",
    props: {
      linkVariant: { type: "String", attribute: "link-variant" },
      advertiserLegalName: { type: "String", attribute: "advertiser-legal-name" },
      funderLegalName: { type: "String", attribute: "funder-legal-name" },
    },
  }}
/>

<script lang="ts">
  import { onMount } from "svelte";
  import type { SponsoredTagV1Props } from "./index.js";
  import { ensureSponsoredSheet } from "../../sponsored-sheet/v1/ensure.js";
  import { SPONSORED_SHEET_ID } from "../../sponsored-sheet/v1/consts.js";

  const {
    linkVariant = "secondary",
    advertiserLegalName,
    funderLegalName,
  }: SponsoredTagV1Props = $props();

  /*                                                                        */
  /*                                                                          */
  const extraData = $derived(
    JSON.stringify({
      advertiserLegalName: advertiserLegalName ?? "",
      funderLegalName: funderLegalName ?? "",
    }),
  );

  /*                                                                         */
  /*                                                                     */
  /*                                                                     */
  /*                                                              */
  onMount(() => {
    ensureSponsoredSheet();
  });
</script>

<oc-link-v2 as-button
            size={"75"}
            variant={linkVariant}
            icon-right="info-hint"
            data-testid="ofc-sponsored-tag-v1"
            data-oc-sheet-v1-open
            data-oc-sheet-v1-open.id={SPONSORED_SHEET_ID}
            data-oc-sheet-v1-open.extra-data={extraData}
>gesponsert</oc-link-v2>
